import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { QrCodeBuildingSectionDto } from '@artemis-software/wr-api';
import { ContractorCredentialsService } from '@services/contractor-credentials.service';
import { qrBuildingContext } from '@services/qr-building-context.service';

@Component({
  standalone: false,
  selector: 'wr-qr-code-building-overview-page',
  templateUrl: './qr-code-building-overview-page.component.html',
  styleUrls: ['./qr-code-building-overview-page.component.scss'],
})
export class QrCodeBuildingOverviewPageComponent {

  private readonly router = inject(Router);
  private readonly credentialsService = inject(ContractorCredentialsService);

  readonly context = qrBuildingContext();

  goToSection(section: QrCodeBuildingSectionDto): void {
    if (this.context.isExternal()) {
      this.context.selectSection(section.id);
      this.router.navigate(this.context.tabPath('tga'));
      return;
    }
    const shortCode = section.shortCodes;
    if (!shortCode || !this.credentialsService.getCurrentPin()) {
      return;
    }
    this.credentialsService.switchShortCode(shortCode);
    this.router.navigate(['/building-qr', shortCode, 'tga']);
  }

}
